(function () {
  window.RemanxPackingSlip = window.RemanxPackingSlip || {};

  var COPY_SENT_ATTR = "data-rmx-copy-sent";

  function $(id) {
    return document.getElementById(id);
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function getForm() {
    return $("RepairRequestForm") || qs("form.rr-form") || qs('form[action*="/contact"]');
  }

  function getByName(name) {
    return qs('[name="' + name.replace(/"/g, '\\"') + '"]');
  }

  function val(idOrName) {
    var el = $(idOrName) || getByName(idOrName);
    return el ? (el.value || "").trim() : "";
  }

  function safe(s) {
    return (s || "").replace(/[<>&"'`]/g, function (c) {
      return ({
        "<": "&lt;",
        ">": "&gt;",
        "&": "&amp;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;"
      })[c];
    });
  }

  function compact(parts, separator) {
    return parts
      .map(function (x) { return (x || "").trim(); })
      .filter(Boolean)
      .join(separator || " ");
  }

  function normaliseText(s) {
    return (s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function getRequestTypeValue() {
    var select = getByName("contact[Request Type]") || qs('[id^="rr-request-type-"]');
    return select ? (select.value || "").trim() : "";
  }

  function getRequestInfo(value) {
    var raw = value || getRequestTypeValue();
    var n = normaliseText(raw);

    /*
      IMPORTANT:
      The repair-check option contains the words "before sending".
      So we MUST check repair-check before assessment.
      Otherwise "sending" gets incorrectly detected as assessment.
    */
    if (
      n.indexOf("check") !== -1 ||
      n.indexOf("before sending") !== -1 ||
      n.indexOf("before send") !== -1 ||
      n.indexOf("can be repaired") !== -1 ||
      n.indexOf("can repair") !== -1
    ) {
      return {
        key: "check",
        raw: raw,
        title: "Repair Check Request",
        badge: "Repair check",
        eyebrow: "Reply required before customer sends unit",
        action: "Customer has not sent the unit yet and is waiting for a reply.",
        printLabel: "Print / Save repair form",
        submitLabel: "Ask if Remanx can repair this",
        subject: "REPAIR CHECK REQUEST — customer waiting for reply",
        internalNote: "REPAIR CHECK REQUEST — customer has not sent the unit yet and is waiting for a reply.",
        needsReturnAddress: false,
        showPrint: false,
        showSubmit: true,
        sendCopyAfterPrint: false
      };
    }

    if (
      n.indexOf("ordered") !== -1 ||
      n.indexOf("already ordered") !== -1 ||
      n.indexOf("packing slip") !== -1
    ) {
      return {
        key: "packing",
        raw: raw,
        title: "Repair Packing Slip",
        badge: "Packing slip",
        eyebrow: "Already ordered online",
        action: "Digital copy sent to Remanx — no reply needed unless details are unclear.",
        printLabel: "Print / Save packing slip and send copy",
        submitLabel: "Send repair request",
        subject: "PACKING SLIP ONLY — customer has already ordered",
        internalNote: "PACKING SLIP ONLY — customer has already ordered. No reply needed unless details are unclear.",
        needsReturnAddress: false,
        showPrint: true,
        showSubmit: false,
        sendCopyAfterPrint: true
      };
    }

    if (
      n.indexOf("assessment") !== -1 ||
      n.indexOf("assess") !== -1 ||
      n.indexOf("sending a unit") !== -1 ||
      n.indexOf("sending unit") !== -1 ||
      n.indexOf("send a unit") !== -1 ||
      n.indexOf("send unit") !== -1
    ) {
      return {
        key: "assessment",
        raw: raw,
        title: "Repair Assessment Form",
        badge: "Assessment",
        eyebrow: "Customer sending unit in",
        action: "Digital copy sent to Remanx. Use the return address on this form when returning the unit.",
        printLabel: "Print / Save assessment form and send copy",
        submitLabel: "Send repair request",
        subject: "ASSESSMENT FORM — customer is sending unit in",
        internalNote: "ASSESSMENT FORM — customer is sending unit in. Return address provided on form.",
        needsReturnAddress: true,
        showPrint: true,
        showSubmit: false,
        sendCopyAfterPrint: true
      };
    }

    return {
      key: raw ? "other" : "none",
      raw: raw,
      title: raw ? "Repair Enquiry" : "Repair Form / Packing Slip",
      badge: raw ? "Other / not sure" : "Select request type",
      eyebrow: raw ? "Customer needs guidance" : "Choose what you want to do",
      action: raw ? "Customer is unsure. Please review and reply." : "",
      printLabel: "Print / Save repair form",
      submitLabel: "Send repair request",
      subject: raw ? "REPAIR ENQUIRY — other / not sure" : "Repair request / packing slip",
      internalNote: raw ? "OTHER / NOT SURE — customer needs guidance. Please review and reply." : "Request type not selected.",
      needsReturnAddress: false,
      showPrint: false,
      showSubmit: true,
      sendCopyAfterPrint: false
    };
  }

  function getLogoUrlFromPage() {
    var btn = qs("[data-rmx-print-slip]");
    var url = btn && btn.dataset ? (btn.dataset.logoUrl || "") : "";
    url = (url || "").trim();
    if (url) return url;

    var img = qs('img[alt*="logo" i], img.site-logo, header img');
    var src = img ? (img.currentSrc || img.src || "") : "";
    return (src || "").trim();
  }

  function readReturnAddressParts() {
    return {
      line1: val("rrf-return-address-1") || val("contact[Return Address Line 1]"),
      line2: val("rrf-return-address-2") || val("contact[Return Address Line 2]"),
      town: val("rrf-return-town") || val("contact[Return Town / City]"),
      postcode: val("rrf-return-postcode") || val("contact[Return Postcode]")
    };
  }

  function readReturnAddress() {
    var oldTextarea =
      val("rrf-return-address") ||
      val("contact[Return Address]");

    if (oldTextarea) return oldTextarea;

    var p = readReturnAddressParts();

    return compact([
      p.line1,
      p.line2,
      p.town,
      p.postcode
    ], "\n");
  }

  function makeFilledData() {
    var request = getRequestInfo();
    var addressParts = readReturnAddressParts();

    return {
      isBlank: false,
      request: request,
      requestType: request.raw,
      title: request.title,
      company: "Remanx Ltd",
      address1: "Unit 12, Northpoint Business Estate",
      address2: "Enterprise Close",
      address3: "Rochester, Kent",
      address4: "ME2 4LX",
      logoUrl: getLogoUrlFromPage(),

      name: val("rrf-name") || val("contact[name]"),
      email: val("rrf-email") || val("contact[email]"),
      phone: val("rrf-phone") || val("contact[Phone]"),
      orderNo: val("rrf-order") || val("contact[Order Number]"),

      returnAddress: readReturnAddress(),
      returnAddressParts: addressParts,

      unitType: val("rrf-unittype") || val("contact[Unit Type]"),
      part: val("rrf-partnumber") || val("contact[Part Number]"),
      make: val("rrf-make") || val("contact[Make]"),
      model: val("rrf-model") || val("contact[Model]"),
      year: val("rrf-year") || val("contact[Year]"),
      reg: val("rrf-reg") || val("contact[Vehicle Registration]"),

      msg: val("rrf-message") || val("contact[body]"),
      codes: val("rrf-codes") || val("contact[Fault Codes]"),
      more: val("rrf-more") || val("contact[More Detail]")
    };
  }

  function makeBlankData() {
    return {
      isBlank: true,
      request: {
        key: "blank",
        raw: "",
        title: "Repair Form / Packing Slip",
        badge: "",
        eyebrow: "Repair details",
        action: "",
        needsReturnAddress: true
      },
      requestType: "",
      title: "Repair Form / Packing Slip",
      company: "Remanx Ltd",
      address1: "Unit 12, Northpoint Business Estate",
      address2: "Enterprise Close",
      address3: "Rochester, Kent",
      address4: "ME2 4LX",
      logoUrl: getLogoUrlFromPage(),

      name: "",
      email: "",
      phone: "",
      orderNo: "",

      returnAddress: "",
      returnAddressParts: {
        line1: "",
        line2: "",
        town: "",
        postcode: ""
      },

      unitType: "",
      part: "",
      make: "",
      model: "",
      year: "",
      reg: "",

      msg: "",
      codes: "",
      more: ""
    };
  }

  function field(label, value, className) {
    return `
      <div class="field ${className || ""}">
        <div class="label">${safe(label)}</div>
        <div class="val">${safe(value)}</div>
      </div>
    `;
  }

  function writeBlock(label, value, className) {
    return `
      <div class="writeGroup ${className || ""}">
        <div class="label">${safe(label)}</div>
        <div class="write">${safe(value)}</div>
      </div>
    `;
  }

  function buildHtml(data) {
    var isBlank = !!data.isBlank;

    var dateStr = new Date().toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });

    var request = data.request || getRequestInfo(data.requestType);
    var logoUrl = (data.logoUrl || "").trim();
    var hasLogo = !!logoUrl;

    var vehicle = compact([data.make, data.model], " ");
    var regYear = compact([data.reg, data.year], " / ");
    var ref = [data.orderNo, data.reg, data.part]
      .filter(function (x) { return !!(x || "").trim(); })
      .join(" • ");

    var addressParts = data.returnAddressParts || {
      line1: "",
      line2: "",
      town: "",
      postcode: ""
    };

    var hasAddressParts = !!(
      addressParts.line1 ||
      addressParts.line2 ||
      addressParts.town ||
      addressParts.postcode
    );

    var customerCard = `
      <section class="card">
        <div class="cardHead">
          <h2>Customer details</h2>
        </div>
        <div class="fields fields--two">
          ${field("Name", data.name)}
          ${field("Phone", data.phone)}
          ${field("Email", data.email, "field--wide")}
          ${field("Order number", data.orderNo)}
        </div>
      </section>
    `;

    var unitCard = `
      <section class="card">
        <div class="cardHead">
          <h2>Unit / vehicle</h2>
        </div>
        <div class="fields fields--two">
          ${field("Unit type", data.unitType)}
          ${field("Part number", data.part)}
          ${field("Vehicle", vehicle)}
          ${field("Reg / year", regYear)}
        </div>
      </section>
    `;

    var returnCard = "";

    if (request.needsReturnAddress || data.returnAddress || isBlank) {
      if (hasAddressParts || isBlank) {
        returnCard = `
          <section class="card card--accent">
            <div class="cardHead">
              <h2>Return address</h2>
            </div>
            <div class="addressGrid">
              ${field("Address line 1", addressParts.line1)}
              ${field("Address line 2", addressParts.line2)}
              ${field("Town / City", addressParts.town)}
              ${field("Postcode", addressParts.postcode)}
            </div>
          </section>
        `;
      } else {
        returnCard = `
          <section class="card card--accent">
            <div class="cardHead">
              <h2>Return address</h2>
            </div>
            <div class="addressBox">${safe(data.returnAddress)}</div>
          </section>
        `;
      }
    }

    var faultCard = `
      <section class="card card--fault">
        <div class="cardHead">
          <h2>Fault details</h2>
        </div>
        ${writeBlock("Fault description", data.msg, isBlank ? "writeGroup--xl" : "")}
        <div class="faultGrid">
          ${writeBlock("Fault codes", data.codes, isBlank ? "writeGroup--lg" : "writeGroup--small")}
          ${writeBlock("More detail", data.more, isBlank ? "writeGroup--lg" : "")}
        </div>
      </section>
    `;

    var reminderCard = `
      <section class="miniCards">
        <div class="miniCard">
          <strong>Include in the box</strong>
          <ul>
            <li>Packing slip must be included.</li>
            <li>Secure packaging around the unit.</li>
            <li>Drain any fluids before sending.</li>
          </ul>
        </div>
        <div class="miniCard">
          <strong>Quick reminders</strong>
          <ul>
            <li>More fault detail helps diagnosis.</li>
            <li>No or missing details can delay your repair.</li>
            <li>Photos and videos are very helpful.</li>
          </ul>
        </div>
      </section>
    `;

    return `
<!doctype html>
<html>
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1"/>
  <title>${safe(data.title || "Repair Form / Packing Slip")}</title>
  <style>
    @page { size: A4 portrait; margin: 10mm; }

    :root {
      --blue: #26489f;
      --yellow: #fdcf09;
      --ink: #0b1220;
      --text: #1f2937;
      --muted: #64748b;
      --line: #dbe4f0;
      --soft: #f6f8fc;
      --paper: #ffffff;
    }

    * { box-sizing: border-box; }

    body {
      margin: 0;
      color: var(--text);
      background: #eef2f7;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12.5px;
      line-height: 1.35;
    }

    .page {
      max-width: 820px;
      margin: 0 auto;
      background: var(--paper);
      border-radius: 18px;
      overflow: hidden;
      box-shadow: 0 18px 50px rgba(15, 23, 42, .12);
    }

    .brandBar {
      height: 8px;
      background: linear-gradient(90deg, var(--blue) 0%, var(--blue) 70%, var(--yellow) 70%, var(--yellow) 100%);
    }

    .header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 18px;
      align-items: start;
      padding: 18px 20px 14px;
      border-bottom: 1px solid var(--line);
      background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
    }

    .logo {
      width: 190px;
      max-height: 62px;
      object-fit: contain;
      object-position: left center;
      display: block;
      margin-bottom: 12px;
    }

    .fallbackLogo {
      display: inline-flex;
      align-items: center;
      min-height: 42px;
      margin-bottom: 12px;
      color: var(--blue);
      font-size: 25px;
      font-weight: 900;
      letter-spacing: -.04em;
    }

    .eyebrow {
      margin: 0 0 5px;
      color: var(--blue);
      font-size: 11px;
      font-weight: 900;
      letter-spacing: .08em;
      text-transform: uppercase;
    }

    h1 {
      margin: 0;
      color: var(--ink);
      font-size: 23px;
      line-height: 1.05;
      letter-spacing: -.035em;
    }

    .actionText {
      margin: 8px 0 0;
      max-width: 520px;
      color: var(--muted);
      font-size: 12.5px;
      font-weight: 700;
    }

    .company {
      min-width: 210px;
      text-align: right;
      color: var(--ink);
    }

    .company strong {
      display: block;
      margin-bottom: 4px;
      font-size: 14px;
      font-weight: 900;
    }

    .addr {
      color: #475569;
      font-size: 11.5px;
      line-height: 1.35;
    }

    .metaRow {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 12px;
      align-items: center;
      padding: 12px 20px;
      border-bottom: 1px solid var(--line);
      background: var(--soft);
    }

    .badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      width: fit-content;
      padding: 8px 11px;
      border: 1px solid #d5e0f6;
      border-radius: 999px;
      background: #fff;
      color: var(--blue);
      font-size: 11px;
      font-weight: 900;
      letter-spacing: .03em;
      text-transform: uppercase;
    }

    .badge::before {
      content: "";
      width: 9px;
      height: 9px;
      border-radius: 999px;
      background: var(--yellow);
      box-shadow: 0 0 0 3px rgba(253, 207, 9, .22);
    }

    .meta {
      color: #475569;
      font-size: 11.5px;
      text-align: right;
      white-space: nowrap;
    }

    .meta strong { color: var(--ink); }

    .content {
      padding: 16px 20px 18px;
    }

    .grid2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin-bottom: 12px;
    }

    .card {
      border: 1px solid var(--line);
      border-radius: 14px;
      background: #fff;
      padding: 13px;
      break-inside: avoid;
      page-break-inside: avoid;
    }

    .card--accent {
      background: linear-gradient(135deg, #ffffff 0%, #fffbea 100%);
      border-color: #f1dc80;
    }

    .cardHead {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      align-items: center;
      margin-bottom: 9px;
    }

    h2 {
      margin: 0;
      color: var(--ink);
      font-size: 13px;
      line-height: 1.1;
      font-weight: 900;
      letter-spacing: -.015em;
    }

    .fields,
    .addressGrid {
      display: grid;
      gap: 8px 12px;
    }

    .fields--two,
    .addressGrid {
      grid-template-columns: 1fr 1fr;
    }

    .field--wide {
      grid-column: 1 / -1;
    }

    .label {
      margin: 0 0 3px;
      color: var(--muted);
      font-size: 10.5px;
      font-weight: 900;
      letter-spacing: .045em;
      text-transform: uppercase;
    }

    .val,
    .addressBox,
    .write {
      min-height: 18px;
      color: var(--text);
      white-space: pre-wrap;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    .val {
      font-size: 12.4px;
      font-weight: 700;
    }

    .addressBox {
      min-height: 64px;
      padding: 10px;
      border: 1px dashed #d8bf4a;
      border-radius: 10px;
      background: rgba(255,255,255,.65);
      font-size: 12.4px;
      font-weight: 700;
      line-height: 1.45;
    }

    .card--fault {
      break-inside: auto;
      page-break-inside: auto;
      margin-bottom: 12px;
    }

    .writeGroup {
      margin-bottom: 10px;
    }

    .writeGroup:last-child {
      margin-bottom: 0;
    }

    .write {
      min-height: 86px;
      padding: 10px;
      border: 1px dashed #cbd5e1;
      border-radius: 10px;
      background: #fbfdff;
      font-size: 12.2px;
      line-height: 1.42;
      break-inside: auto;
      page-break-inside: auto;
    }

    .writeGroup--small .write {
      min-height: 58px;
    }

    .writeGroup--xl .write {
      min-height: 250px;
    }

    .writeGroup--lg .write {
      min-height: 158px;
    }

    .faultGrid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }

    .miniCards {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin-top: 12px;
    }

    .miniCard {
      border: 1px solid var(--line);
      border-radius: 14px;
      padding: 12px;
      background: var(--soft);
    }

    .miniCard strong {
      display: block;
      margin-bottom: 7px;
      color: var(--ink);
      font-size: 12.5px;
      font-weight: 900;
    }

    .miniCard ul {
      margin: 0;
      padding-left: 18px;
    }

    .miniCard li {
      margin: 4px 0;
      color: #475569;
      font-size: 11.4px;
      font-weight: 700;
    }

    .footer {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 14px;
      align-items: center;
      padding: 12px 20px 16px;
      border-top: 1px solid var(--line);
      color: #475569;
      font-size: 11.5px;
      font-weight: 700;
    }

    .footerMark {
      color: var(--blue);
      font-size: 13px;
      font-weight: 900;
      white-space: nowrap;
    }

    .page--blank .brandBar {
      height: 6px;
    }

    .page--blank .header {
      padding: 11px 16px 9px;
    }

    .page--blank .logo {
      width: 145px;
      max-height: 44px;
      margin-bottom: 6px;
    }

    .page--blank .fallbackLogo {
      min-height: 34px;
      margin-bottom: 6px;
      font-size: 22px;
    }

    .page--blank .eyebrow {
      margin-bottom: 3px;
      font-size: 10px;
    }

    .page--blank h1 {
      font-size: 20px;
    }

    .page--blank .company strong {
      font-size: 12.5px;
    }

    .page--blank .addr {
      font-size: 10.5px;
    }

    .page--blank .content {
      padding: 10px 16px 12px;
    }

    .page--blank .grid2 {
      gap: 8px;
      margin-bottom: 8px;
    }

    .page--blank .card {
      padding: 8px;
      border-radius: 11px;
    }

    .page--blank .cardHead {
      margin-bottom: 5px;
    }

    .page--blank h2 {
      font-size: 12px;
    }

    .page--blank .fields,
    .page--blank .addressGrid {
      gap: 5px 9px;
    }

    .page--blank .label {
      font-size: 9.5px;
      margin-bottom: 2px;
    }

    .page--blank .val {
      font-size: 11.4px;
      min-height: 15px;
    }

    .page--blank .writeGroup {
      margin-bottom: 7px;
    }

    .page--blank .write {
      min-height: 62px;
      padding: 7px;
      border-radius: 8px;
      font-size: 11px;
      line-height: 1.3;
    }

    .page--blank .writeGroup--xl .write {
      min-height: 125px;
    }

    .page--blank .writeGroup--lg .write {
      min-height: 68px;
    }

    .page--blank .faultGrid {
      gap: 8px;
    }

    .page--blank .footer {
      padding: 8px 16px 9px;
      font-size: 10.4px;
    }

    .page--blank .footerMark {
      font-size: 11px;
    }

    @media print {
      body {
        background: #fff;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .page {
        max-width: none;
        box-shadow: none;
        border-radius: 0;
      }

      .card {
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .card--fault {
        break-inside: auto;
        page-break-inside: auto;
      }

      .card--fault .write {
        break-inside: auto;
        page-break-inside: auto;
      }

      h2,
      .label {
        break-after: avoid;
        page-break-after: avoid;
      }
    }

    @media screen {
      body {
        padding: 18px;
      }
    }
  </style>
</head>

<body>
  <div class="page ${isBlank ? "page--blank" : ""}">
    <div class="brandBar"></div>

    <header class="header">
      <div>
        ${hasLogo ? `<img class="logo" src="${safe(logoUrl)}" alt="Remanx logo">` : `<div class="fallbackLogo">Remanx</div>`}
        <p class="eyebrow">${safe(request.eyebrow || "Repair details")}</p>
        <h1>${safe(data.title || "Repair Form / Packing Slip")}</h1>
        ${!isBlank && request.action ? `<p class="actionText">${safe(request.action)}</p>` : ``}
      </div>

      <div class="company">
        <strong>${safe(data.company || "Remanx Ltd")}</strong>
        <div class="addr">
          ${safe(data.address1 || "")}${data.address1 ? "<br>" : ""}
          ${safe(data.address2 || "")}${data.address2 ? "<br>" : ""}
          ${safe(data.address3 || "")}${data.address3 ? "<br>" : ""}
          ${safe(data.address4 || "")}
        </div>
      </div>
    </header>

    ${!isBlank ? `
      <div class="metaRow">
        <div class="badge">${safe(request.badge || "Repair form")}</div>
        <div class="meta">
          <strong>Generated:</strong> ${safe(dateStr)}
          ${ref ? `<br><strong>Ref:</strong> ${safe(ref)}` : ``}
        </div>
      </div>
    ` : ``}

    <main class="content">
      <div class="grid2">
        ${customerCard}
        ${unitCard}
      </div>

      ${returnCard}
      ${returnCard ? `<div style="height:${isBlank ? "8px" : "12px"}"></div>` : ``}

      ${faultCard}

      ${!isBlank ? reminderCard : ``}
    </main>

    <footer class="footer">
      <div>Please include this sheet in the box with your unit. Clear details help us identify and process your repair faster.</div>
      <div class="footerMark">Find. Send. Fixed.</div>
    </footer>
  </div>
</body>
</html>`;
  }

  function addEmailLine(lines, label, value) {
    value = (value || "").trim();
    if (!value) return;
    lines.push(label + ": " + value);
  }

  function addEmailSection(lines, title) {
    lines.push("");
    lines.push(title.toUpperCase());
    lines.push("----------------------------------------");
  }

  function buildCleanEmailBody(data) {
    var request = data.request || getRequestInfo();
    var lines = [];

    lines.push(request.subject || "Repair request");
    lines.push("");

    if (request.key === "check") {
      lines.push("Customer has not sent the unit yet and is waiting for a reply.");
    } else if (request.key === "packing") {
      lines.push("Customer has already ordered online. No reply needed unless details are unclear.");
    } else if (request.key === "assessment") {
      lines.push("Customer is sending the unit in for assessment.");
    } else {
      lines.push("Customer selected Other / not sure. Please review and reply.");
    }

    addEmailSection(lines, "Customer details");
    addEmailLine(lines, "Name", data.name);
    addEmailLine(lines, "Email", data.email);
    addEmailLine(lines, "Phone", data.phone);
    addEmailLine(lines, "Order number", data.orderNo);

    if (data.returnAddress) {
      addEmailSection(lines, "Return address");
      lines.push(data.returnAddress);
    }

    addEmailSection(lines, "Vehicle / part details");
    addEmailLine(lines, "Unit type", data.unitType);
    addEmailLine(lines, "Part number", data.part);
    addEmailLine(lines, "Make", data.make);
    addEmailLine(lines, "Model", data.model);
    addEmailLine(lines, "Year", data.year);
    addEmailLine(lines, "Registration", data.reg);

    addEmailSection(lines, "Fault details");
    addEmailLine(lines, "Fault description", data.msg);
    addEmailLine(lines, "Fault codes", data.codes);
    addEmailLine(lines, "More detail", data.more);

    addEmailSection(lines, "Internal");
    addEmailLine(lines, "Request type", data.requestType);
    addEmailLine(lines, "Form action", request.badge);
    addEmailLine(lines, "Internal note", request.internalNote);

    if (data.digitalCopy) {
      addEmailLine(lines, "Digital copy", "Sent automatically after customer printed/saved the form.");
    }

    return lines.join("\n");
  }

  function setHidden(name, value) {
    var form = getForm();
    if (!form) return;

    var input = qs('[name="' + name.replace(/"/g, '\\"') + '"]', form);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }

    input.value = value || "";
  }

  function syncHiddenEmailFields(data) {
    var request = data.request || getRequestInfo();

    setHidden("contact[Subject]", request.subject || "Repair request / packing slip");
    setHidden("contact[Form Type]", "Repair Form / Repair Request");
    setHidden("contact[Form Action]", request.badge || "Repair form");
    setHidden("contact[Internal Note]", request.internalNote || "");

    if (data.returnAddress) {
      setHidden("contact[Return Address]", data.returnAddress);
    }
  }

  function disableNoisyContactFieldsForSubmit(form) {
    if (!form) return;

    var keepNames = {
      "contact[name]": true,
      "contact[email]": true,
      "contact[body]": true,
      "contact[Subject]": true
    };

    qsa('input[name^="contact["], select[name^="contact["], textarea[name^="contact["]', form).forEach(function (field) {
      if (keepNames[field.name]) return;
      field.disabled = true;
    });
  }

  function prepareCleanEmailSubmit(data) {
    var form = getForm();
    if (!form) return;

    syncHiddenEmailFields(data);

    var bodyField = getByName("contact[body]");

    if (!bodyField) {
      bodyField = document.createElement("textarea");
      bodyField.name = "contact[body]";
      bodyField.hidden = true;
      form.appendChild(bodyField);
    }

    bodyField.value = buildCleanEmailBody(data);

    disableNoisyContactFieldsForSubmit(form);
  }

  function openAndPrint(html, afterPrint) {
    var iframe = document.createElement("iframe");

    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");

    document.body.appendChild(iframe);

    var win = iframe.contentWindow;
    var doc = win && win.document;

    if (!doc) {
      alert("Unable to print. Please try a different browser.");
      try { document.body.removeChild(iframe); } catch (e) {}
      return;
    }

    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;

      if (typeof afterPrint === "function") {
        afterPrint();
      }

      setTimeout(function () {
        try { document.body.removeChild(iframe); } catch (e) {}
      }, 700);
    }

    doc.open();
    doc.write(html);
    doc.close();

    var tries = 0;

    (function tryPrint() {
      tries++;

      var imgs = doc.images || [];
      var allLoaded = true;

      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].complete) {
          allLoaded = false;
          break;
        }
      }

      if (allLoaded || tries > 24) {
        try {
          if ("onafterprint" in win) {
            win.onafterprint = finish;
          }

          win.focus();
          win.print();

          setTimeout(finish, 2500);
        } catch (e) {
          finish();
        }

        return;
      }

      setTimeout(tryPrint, 150);
    })();
  }

  function validateFilled(data, options) {
    var errors = [];
    var warnings = [];
    var request = data.request || getRequestInfo();
    var requirePrintFields = options && options.printing;

    if (!request.raw && !data.isBlank) {
      errors.push("Please select what you want to do.");
    }

    if (!data.msg) {
      errors.push("Fault description is required.");
    }

    if (!data.email && !data.phone) {
      errors.push("Please provide at least Email or Phone.");
    }

    if (request.key === "packing" && !data.orderNo) {
      errors.push("Order number is required for a packing slip.");
    }

    if (request.key === "assessment") {
      var hasTextareaAddress = !!data.returnAddress;
      var p = data.returnAddressParts || readReturnAddressParts();

      if (!hasTextareaAddress) {
        if (!p.line1) errors.push("Return address line 1 is required.");
        if (!p.town) errors.push("Town / City is required.");
        if (!p.postcode) errors.push("Postcode is required.");
      }
    }

    if (requirePrintFields && !data.reg) {
      warnings.push("Registration is blank. This is recommended but not required.");
    }

    if (requirePrintFields && !data.part) {
      warnings.push("Part number is blank. This is recommended but not required.");
    }

    return {
      errors: errors,
      warnings: warnings
    };
  }

  function submitDigitalCopy(data) {
    var form = getForm();

    if (!form) return;
    if (form.getAttribute(COPY_SENT_ATTR) === "true") return;

    form.setAttribute(COPY_SENT_ATTR, "true");

    data.digitalCopy = true;
    prepareCleanEmailSubmit(data);

    form.submit();
  }

  function printFilled() {
    var data = makeFilledData();
    var request = data.request || getRequestInfo();
    var v = validateFilled(data, { printing: true });

    if (v.errors.length) {
      alert(v.errors.join("\n"));
      return;
    }

    if (v.warnings.length) {
      if (!confirm(v.warnings.join("\n") + "\n\nPrint anyway?")) {
        return;
      }
    }

    syncHiddenEmailFields(data);

    openAndPrint(buildHtml(data), function () {
      if (request.sendCopyAfterPrint) {
        submitDigitalCopy(data);
      }
    });
  }

  function printBlank() {
    openAndPrint(buildHtml(makeBlankData()));
  }

  function setButtonVisible(buttons, visible) {
    buttons.forEach(function (btn) {
      btn.style.display = visible ? "" : "none";
      btn.hidden = !visible;
    });
  }

  function setButtonLabel(btn, label, labelSelector) {
    if (!btn) return;

    var labelEl = labelSelector ? qs(labelSelector, btn) : null;

    if (labelEl) {
      labelEl.textContent = label;
    } else {
      btn.textContent = label;
    }
  }

  function getReturnAddressWrap() {
    var field =
      $("rrf-return-address-1") ||
      $("rrf-return-address") ||
      getByName("contact[Return Address Line 1]") ||
      getByName("contact[Return Address]");

    return qs("[data-rmx-return-address]") ||
      (field && field.closest ? field.closest("fieldset") || field.closest(".rr-field") : null);
  }

  function applyRequestTypeUi() {
    var select = getByName("contact[Request Type]") || qs('[id^="rr-request-type-"]');
    var request = getRequestInfo(select ? select.value : "");
    var form = getForm();

    var submitButtons = form ? qsa('button[type="submit"], input[type="submit"]', form) : [];
    var printButtons = qsa("[data-rmx-print-slip]").concat(qsa('[id^="rrf-print-slip-"]'));

    printButtons = printButtons.filter(function (btn, index, arr) {
      return arr.indexOf(btn) === index;
    });

    setButtonVisible(submitButtons, request.showSubmit);
    setButtonVisible(printButtons, request.showPrint);

    submitButtons.forEach(function (btn) {
      setButtonLabel(btn, request.submitLabel || "Send repair request", "[data-rmx-submit-label]");
    });

    printButtons.forEach(function (btn) {
      setButtonLabel(btn, request.printLabel || "Print / Save repair form", "[data-rmx-print-label]");
    });

    var returnWrap = getReturnAddressWrap();

    if (returnWrap) {
      returnWrap.hidden = !request.needsReturnAddress;
      returnWrap.style.display = request.needsReturnAddress ? "" : "none";
    }

    var oldTextarea = $("rrf-return-address") || getByName("contact[Return Address]");

    if (oldTextarea) {
      oldTextarea.required = !!request.needsReturnAddress;
      oldTextarea.setAttribute("aria-required", request.needsReturnAddress ? "true" : "false");
    }

    [
      $("rrf-return-address-1") || getByName("contact[Return Address Line 1]"),
      $("rrf-return-town") || getByName("contact[Return Town / City]"),
      $("rrf-return-postcode") || getByName("contact[Return Postcode]")
    ].forEach(function (field) {
      if (!field) return;

      field.required = !!request.needsReturnAddress;
      field.setAttribute("aria-required", request.needsReturnAddress ? "true" : "false");
    });

    var optionalAddressLine =
      $("rrf-return-address-2") ||
      getByName("contact[Return Address Line 2]");

    if (optionalAddressLine) {
      optionalAddressLine.required = false;
      optionalAddressLine.setAttribute("aria-required", "false");
    }

    syncHiddenEmailFields(makeFilledData());
  }

  function bindButtons() {
    var printButtons = qsa("[data-rmx-print-slip]").concat(qsa('[id^="rrf-print-slip-"]'));

    printButtons = printButtons.filter(function (btn, index, arr) {
      return arr.indexOf(btn) === index;
    });

    printButtons.forEach(function (btn) {
      if (btn.getAttribute("data-rmx-print-bound") === "true") return;

      btn.setAttribute("data-rmx-print-bound", "true");

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        printFilled();
      });
    });

    var form = getForm();

    if (form && form.getAttribute("data-rmx-clean-email-bound") !== "true") {
      form.setAttribute("data-rmx-clean-email-bound", "true");

      form.addEventListener("submit", function () {
        prepareCleanEmailSubmit(makeFilledData());
      });
    }

    var select = getByName("contact[Request Type]") || qs('[id^="rr-request-type-"]');

    if (select && select.getAttribute("data-rmx-mode-bound") !== "true") {
      select.setAttribute("data-rmx-mode-bound", "true");
      select.addEventListener("change", applyRequestTypeUi);
      select.addEventListener("input", applyRequestTypeUi);
    }
  }

  window.RemanxPackingSlip.printBlank = printBlank;
  window.RemanxPackingSlip.printFilled = printFilled;
  window.RemanxPackingSlip.applyRequestTypeUi = applyRequestTypeUi;

  function init() {
    bindButtons();
    applyRequestTypeUi();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();